// extracted by mini-css-extract-plugin
export default {"title":"Products_title__8RQJG","description":"Products_description__h9zkR","card":"Products_card__HffGw"};